// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect,
  useMemo, useState} from 'react';
import styles from './bubbles.module.less';
import cn from 'classnames';
import {Link, useHistory} from 'react-router-dom';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {App_context} from 'hola_app_context';
import {Faq_question} from './faq_section';
import {i_popup_props_base} from '../../../../hola/pub/ui/popup';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {Editor} from '../../../../shared/editor/editor';
import {Button} from '../../../../shared/ui/button';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

export interface i_bubble_info {
    id?: string;
    text: string;
    tooltip?: string;
    tooltip_img?: string|JSX.Element;
    link?: string;
    blue_bg_hover?: boolean;
}
type t_bubble_colors = 'blue' | 'neutrals' | 'green' | 'purple' | 'brown'
    | 'pink' | 'transparent';
interface i_bubbles_props {
    cases?: i_bubble_info[];
    all_in_mobile?: boolean;
    tile_bg_color?: t_bubble_colors;
    tile_bg_color_hover?: t_bubble_colors;
    tile_text_color?: t_bubble_colors;
    tooltip_bg_color?: t_bubble_colors;
    filter?: any;
    has_hover?: boolean;
    use_case_page?: boolean;
    lines?: Array<(string|JSX.Element)[]>;
    title?: string | JSX.Element;
    title_tag?: string;
    cms_title?: string;
    popup_props?: Partial<i_popup_props_base>;
    show_more_el?: string | JSX.Element;
    ui_for_user?: boolean;
}

interface i_bubbles_props_editor {
    value: i_bubbles_props;
    on_change: (v:i_bubbles_props)=>void;
    on_cancel: ()=>void;
}

const colors = 'blue, neutrals, green, purple, brown, pink, transparent';
export const Bubbles_editor = (props: i_bubbles_props_editor)=>{
    const [state, set_state] = useState<i_bubbles_props>(()=>({
        title: props.value?.title ?? '',
        cases: props.value?.cases ?? [],
    }));
    const cases = state.cases || [];
    useEffect(()=>{
        set_state(c=>({...c, ...props.value}));
    }, [props.value]);
    return <Editor
      value={state}
      editors={[
        {key: 'cms_title', label: 'Title:', type: 'text'},
        {key: 'title_tag', label: 'Title Tag:', type: 'select_tag_selector'},
        {key: 'tile_bg_color', label: 'tile_bg_color: '+colors, type: 'text'},
        {key: 'tile_bg_color_hover', label: 'tile_bg_color_hover: '+colors,
          type: 'text'},
        {key: 'tile_text_color', label: 'tile_text_color: '+colors,
          type: 'text'},
        {key: 'tooltip_bg_color', label: 'tooltip_bg_color: '+colors,
          type: 'text'},
        {key: 'all_in_mobile', label: 'all_in_mobile', type: 'boolean'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}>
      <h4>Cases: </h4>
      {cases.map((li, i)=>
        <Editor
          title={li.text || `unknown`}
          key={i}
          value={li}
          editors={[
            {key: 'text', label: 'Text', type: 'textarea'},
            {key: 'tooltip', label: 'Tooltip', type: 'textarea'},
            {key: 'tooltip_img', label: 'Tooltip Img', type: 'text'},
            {key: 'link', label: 'Link', type: 'text'},
            {key: 'blue_bg_hover', label: 'blue_bg_hover', type: 'boolean'},
          ]}
          on_change={v=>{
            const items_new = [...cases];
            items_new[i] = v;
            set_state({...state, cases: items_new});
          }}>
        </Editor>
      )}
      <Button caption={'Add case'} size={'xs'}
        on_click={()=>{
          set_state({...state, cases: [...cases, {
            text: '',
            tooltip: '',
            tooltip_img: '',
            id: '',
            link: '',
            blue_bg_hover: false,
          }]});
        }}/>
      <br/>
    </Editor>;
};

export const Bubbles = (props:i_bubbles_props)=>{
    const {tile_bg_color = 'blue', tile_bg_color_hover = 'blue',
        tile_text_color = 'blue', tooltip_bg_color = 'purple', lines,
        title, show_more_el = 'Show more', cms_title} = props;
    const {T} = use_translation_v({no_defaults: true});
    const [visible_count, set_visible_count] = useState(5);
    const {theme, show_popup, close_popup} = useContext(Settings_context);
    const bubbles = useMemo<i_bubble_info[]>(()=>{
        if (props.cases)
            return props.filter ? props.filter(props.cases) : props.cases;
        // XXX dmitriiz: remove after migration to CMS
        const real_b = [{
            text: 'Advertising Optimization',
            tooltip: `Make sure your ads and campaigns are performing as they
              should be, are placed where they are meant to be and
              getting you the results you want.`,
            tooltip_img: 'cases_ads',
        }, {
            text: 'SEO and SERP',
            tooltip: `Check how your website is performing globally, at
              anytime. Leads, rankings, engagement metrics — the insights
              are all at your fingertips.`,
            tooltip_img: 'cases_seo',
        }, {
            text: 'Market Research',
            tooltip: `If you want to reach a high intention audience, market
              research is key to optimizing sales funnels and results.`,
            tooltip_img: 'cases_market',
        }, {
            text: 'Social Media',
            tooltip: `Manage multiple brands' social media accounts and need
              to ensure smooth access to each page? Multiple IPs guarantee
              smooth connections!`,
            tooltip_img: 'cases_social',
        }, {
            text: 'Price Monitoring',
            tooltip: `Get the edge over your competition and economic trends.
              Optimize pricing strategies and get the benefits of a bigger
              market share.`,
            tooltip_img: 'cases_price',
        }, {
            text: 'Data Scraping',
            tooltip: `Get accurate and trusted data from anywhere on the web.
              Stay ahead of the game, and do it anonymously.`,
            tooltip_img: 'cases_datascrapping',
        }, {
            text: 'Brand Protection',
            tooltip: `A brand needs protection and optimization. With the
              right data, check both those boxes and win a bigger market
              share.`,
            tooltip_img: 'cases_brand',
        }, {
            text: 'Global Travel Data Comparisons',
            tooltip: `Compare prices with your competition in the travel
              industry and keep your pricing edge. Make sure you always
              have the right promotions running!`,
            tooltip_img: 'cases_travel',
        }, {
            text: 'Anti-Fraud',
            tooltip: `Make sure your product, site, or brand are not being
              used for nefarious purposes. Track this accurately with the
              right data.`,
            tooltip_img: 'cases_anti_fraud',
        }, {
            text: 'Content Streaming',
            tooltip: `Get IMMEDIATE access to Worldwide streaming, without
              compromising your IP address`,
            tooltip_img: 'cases_content',
        }, {
            text: 'AI Training',
            tooltip: `Proxies help AI perform better by allowing access to
              diverse, uninterrupted data. This ensures accurate and
              well-rounded AI training by reducing bias and improving
              adaptability.`,
            toolip_img: 'ai_training',
        }];
        return props.filter ? props.filter(real_b) : real_b;
    }, [props.filter]);
    const {is_client} = useContext(App_context);
    const {debug_tr} = use_qs();
    const history = useHistory();
    const {width} = use_screen();
    const scroll_to_top = ()=>{
      window.scrollTo({top: 0, behavior: 'smooth'});
    };

    const show_more = ()=>{
      set_visible_count(prev_count=>prev_count + 5);
    };

    if (!is_client && !debug_tr)
        return null;
    if (width<1150)
    {
        const faq_cls = cn(styles.faq_bubbles, styles.short);
        return <div className={styles.use_cases_mobile}>
          {cms_title ? <Dynamic_heading tag={props.title_tag || 'h2'}
            dangerouslySetInnerHTML={{__html: cms_title}}/> : null}
          {!title ? null : typeof title=='string' ? <Dynamic_heading
            tag={props.title_tag || 'hd'}><T>{title}</T></Dynamic_heading> :
            title}
          <div className={faq_cls}>
            {bubbles.slice(0, visible_count).map((b, i)=>
              <Faq_question quest={b.text} key={i}
                ans={<Fragment>{b.tooltip}</Fragment>}
                transparent_style={tile_bg_color=='transparent'}
                blue_bg_hover={b.blue_bg_hover}
                is_continent={Array.isArray(b.tooltip)}/>
            )}
          </div>
          {visible_count < bubbles.length && <a className={styles.show_more}
            onClick={show_more}><T>{show_more_el}</T></a>
          }
        </div>;
    }
    const bubble_cls = cn(styles.bubble_text,
        styles[`${tile_bg_color}_bg`],
        styles[`${tile_bg_color_hover}_bg_hover`],
        styles[`${tile_text_color}_text`], theme.med);
    const sections = lines || [bubbles];
    return <Fragment>
      {cms_title ? <h2 dangerouslySetInnerHTML={{__html: cms_title}}
        className={styles.b_title}/> : null}
      {sections.map((items, j)=>{
        return <div key={j} className={props.ui_for_user ? styles.bubbles_flex
          : cn(styles.bubbles_flex, styles.bubbles_flex_v2)
        }>
          {items.map((b, i)=>{
            if (React.isValidElement(b))
              return b;
            if (typeof b == 'string')
              b = bubbles.find(el=>el.id==b || el.text==b);
            const on_click = e=>{
              if (!b?.link)
                return;
              e.stopPropagation();
              window.scrollTo({top: 0, behavior: 'smooth'});
              history.push(b.link);
            };
            return <div key={i} className={bubble_cls}
              onMouseEnter={ev=>{
                if (props.has_hover === false)
                  return;
                show_popup(`case_${i}`, ()=>{
                  return <div className={styles.cases_tooltip}>
                    <div className={cn(styles.img, styles[tooltip_bg_color])}>
                      {typeof b.tooltip_img =='string'
                        ? <img src={toolip_img_url(`toolip/${b.tooltip_img}.png`)}/>
                        : b.tooltip_img}
                    </div>
                    <p className={cn(theme.mono16)}><T>{b.tooltip}</T></p>
                  </div>;
                },
                {
                  strategy: 'bind auto auto center',
                  // @ts-ignore
                  anchor_element: ev.target,
                  cls: '',
                  // @ts-ignore
                  parent: ev.target,
                  offset_top: -225,
                  offset_top_fallback: 74,
                  timeout: 100,
                  ...props.popup_props,
                });
              }}
              onMouseLeave={()=>{
                if (props.has_hover === false)
                  return;
                close_popup(`case_${i}`);
              }}
              onClick={on_click}>
              {b.link ?
                <Link to={b.link} onClick={scroll_to_top}>
                  <T>{b.text}</T>
                </Link>
              :
                <p className={theme.med}><T>{b.text}</T></p>
              }
            </div>;
          })}
      </div>;
    })}
    </Fragment>;
};
